import { FC } from 'react';
import { Typography, Stack } from '@optimus-web/core';
import { ActionLogItem, ActionLogItemActionType } from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { intersperse } from '@mews/fp';

interface ActionLogItemTextProps {
    actionLogItem: ActionLogItem;
}

const ActionLogItemText: FC<ActionLogItemTextProps> = ({ actionLogItem }) => {
    if (actionLogItem.payload.discriminator === 'Legacy') {
        return (
            <Typography textStyle="bodyMediumStrong" as="div">
                {intersperse(<br />, actionLogItem.payload.value.changes.split('\n'))}
            </Typography>
        );
    }

    const sentences = actionLogItem.payload.value.changes.map((change) => {
        const oldState = change.old.description ?? (change.old.value as string);
        const newState = change.new.description ?? (change.new.value as string);

        const sentence = `${change.name} ${getChangeDescText(change.actionType)} ${
            oldState ? `from ${oldState}` : ''
        } to ${newState || 'none'}`;

        return sentence;
    });

    const { note } = actionLogItem.payload.value;

    return (
        <Stack vertical>
            {sentences.map((sentence) => (
                <Typography textStyle="bodyMediumStrong" as="div">
                    {sentence}
                </Typography>
            ))}
            {note ? (
                <Typography textStyle="bodyMediumStrong" as="div">
                    {note}
                </Typography>
            ) : null}
        </Stack>
    );
};

const getChangeDescText = createHandler({
    [ActionLogItemActionType.Change]: 'changed',
    [ActionLogItemActionType.Move]: 'moved',
});

export default ActionLogItemText;
